import {Component, ElementRef, Input, OnInit, Renderer2, ViewChild} from '@angular/core';
import {  Router } from "@angular/router";
import { SocialShareComponentGeneric } from "@signature-it/ngx-generic/components/social-share";
import { OverlayContainer } from '@angular/cdk/overlay';


@Component({
    selector: 'social-share-teldor',
    templateUrl: './social-share.component.html',
    styleUrls: ['./social-share.component.scss', '../../../../projects/signature-it/ngx-generic/components/social-share/social-share.component.scss'],
    standalone: false
})
export class SocialShareComponent extends SocialShareComponentGeneric  implements OnInit {
    @Input('showText') showText = false;
    @ViewChild('shareBtn') shareBtn: ElementRef;

    // @ViewChild('shareMenu') shareMenu: ElementRef;
    isShareOpen = false;
    _includeButton:any;
    get includeButton():any{
        return this._includeButton;
    }
    @Input() set includeButton(value:any) {
        this._includeButton = value === 'false' ? false : true;
    }

    _shareBtns: any = ['facebook', 'twitter', 'whatsapp', 'email'];
    get shareBtns():any{
        return this._shareBtns;
    }
    @Input() set shareBtns(value:any) {
        if (typeof value === 'string'){
            this._shareBtns = value.split('|');
        }else{
            this._shareBtns = value || ['facebook', 'twitter', 'whatsapp', 'email'];
        }
    }

    @Input() IsListenUrl = true;
    @Input() url:string;
    @Input() titleEmail:string = '';
    @Input() bodyEmail:string = '';
    @Input() linkInBodyEmail:string = null;
    href;
    constructor(
        public renderer: Renderer2,
        protected router: Router,
        protected overlayContainer: OverlayContainer
    ) {
        super(renderer, router, overlayContainer);
    }
    ngOnInit() {
        super.ngOnInit();
        //build the href to email-share-btn...
        this.href = `mailto:?subject=${this.titleEmail}&body=${this.bodyEmail}`;
        this.href = this.linkInBodyEmail? `${this.href}${this.linkInBodyEmail}` : this.href;
    }

    share() {
        this.isShareOpen = !this.isShareOpen;
        location.hash = '';
    }

    focusout(event) {

    }

}
